import { useAppDispatch } from 'store/hooks.ts';
import { useEffect, useState } from 'react';
import { setHealth } from 'store/connection/connection.actions.ts';
import { fetchIADataSet } from 'store/ia/ia.thunk.ts';
import { fetchPADataSet } from 'store/pa/pa.thunk.ts';

const useStartHealthChecker = () => {
  const [checkIsOnline, setCheckIsOnline] = useState(navigator.onLine);
  const dispatch = useAppDispatch();

  useEffect(() => {
    const goOnline = () => setCheckIsOnline(true);
    const goOffline = () => setCheckIsOnline(false);

    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);

    // AuthPage is the layout element for every route, so it remounts on each page
    // load. Without this the online/offline listeners accumulate one pair per mount.
    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  useEffect(() => {
    dispatch(setHealth(checkIsOnline));
    if (checkIsOnline) {
      const fetchData = async () => {
        await dispatch(fetchIADataSet());
        await dispatch(fetchPADataSet());
      };
      fetchData();
    }
  }, [checkIsOnline]);
};

export default useStartHealthChecker;
